import validator from "validator";

// function validateEmail(email) {
//   var re = /\S+@\S+\.\S+/;
//   return re.test(email);
// }

// function validateString(string) {
//   var re = /^[a-zA-Z ]{2,30}$/;
//   return re.test(string);
// }

// function validateDate(dateString) {
//   var regEx = /^\d{4}-\d{2}-\d{2}$/;
//   if (!dateString.match(regEx)) return false; // Invalid format
//   var d = new Date(dateString);
//   var dNum = d.getTime();
//   if (!dNum && dNum !== 0) return false; // NaN value,
//   return true;
//   // var dateformat =
//   //   /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
//   // // Match the date format through regular expression
//   // if (inputText.match(dateformat)) {
//   //   // document.form1.text1.focus();
//   //   //Test which seperator is used '/' or '-'
//   //   var opera1 = inputText.split('/');
//   //   var opera2 = inputText.split('-');
//   //   let lopera1 = opera1.length;
//   //   let lopera2 = opera2.length;
//   //   // Extract the string into month, date and year
//   //   if (lopera1 > 1) {
//   //     var pdate = inputText.split('/');
//   //   } else if (lopera2 > 1) {
//   //     var pdate = inputText.split('-');
//   //   }
//   //   var dd = parseInt(pdate[0]);
//   //   var mm = parseInt(pdate[1]);
//   //   var yy = parseInt(pdate[2]);
//   //   // Create list of days of a month [assume there is no leap year by default]
//   //   var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
//   //   if (mm === 1 || mm > 2) {
//   //     if (dd > ListofDays[mm - 1]) {
//   //       return false;
//   //     }
//   //   }
//   //   if (mm === 2) {
//   //     var lyear = false;
//   //     if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
//   //       lyear = true;
//   //     }
//   //     if (lyear === false && dd >= 29) {
//   //       return false;
//   //     }
//   //     if (lyear === true && dd > 29) {
//   //       return false;
//   //     }
//   //   }
//   // } else {
//   //   return false;
//   // }
//   // return true;
// }


export function validateNumber(numb) {
  let p = /^[0-9]*$/;
  return p.test(numb);
  // return validator.isNumeric(numb)
}

export function validString(string) {
  // var re = /^[a-zA-Z ]{2,30}$/;
  // return re.test(string);
  return validator.isAlphanumeric(string, ['en-US'], { 'ignore': ' ' })
}

// function validatePhone(phoneNo) {
//   let p = /^(?:\971|00971|0)(?!2)((?:2|3|4|5|6|7|9|50|51|52|55|56)[0-9]{7,})$/;
//   return p.test(phoneNo);
// }

export const validateSignIn = (email, password) => {
  if (email.trim() === "") {
    return {
      status: false,
      message: "Email Address can not be empty",
      type: "emailError",
    };
  }
  if (password.trim() === "") {
    return {
      status: false,
      message: "Password can not be empty",
      type: "passwordError",
    };
  }

  if (!validator.isEmail(email.trim().toLowerCase())) {
    return {
      status: false,
      message: "Invalid Email Address",
      type: "emailError",
    };
  }

  return { status: true, message: "", type: "" };
};
export const validateForgotPassword = (email, password) => {
  if (email === "") {
    return {
      status: false,
      message: "Email address can not be empty",
      type: "emailError",
    };
  }
  if (!validator.isEmail(email.toLowerCase())) {
    return {
      status: false,
      message: "Invalid email address",
      type: "emailError",
    };
  }
  if (password === "") {
    return {
      status: false,
      message: "Password can not be empty",
      type: "passwordError",
    };
  }
};
export const validateAddSchoolForm = (
  name,
  address,
  merchantId
) => {
  let response = [];
  if (name?.trim() === "") {
    response.push("name");
  }
  if (address?.trim() === "") {
    response.push("address");
  }
  if (merchantId?.trim() === "") {
    response.push("merchantId");
  }

  return response;
};

export const validateAddInvoiceForm = (balanceVal, dueDate) => {
  let response = [];
  if (balanceVal.trim() === "" || balanceVal === 0 || balanceVal === undefined) {
    response.push("balanceVal");
  }
  if (dueDate?.trim() === "") {
    response.push("dueDate");
  }
  return response;
};

export const validateAddStudentForm = (
  firstName,
  lastName,
  dob,
  email,
  phoneNumber
) => {
  let response = [];
  if (firstName.trim() === "") {
    response.push("firstName");
  }
  if (lastName.trim() === "") {
    response.push("lastName");
  }
  if (dob.trim() === "") {
    response.push("dob");
  }
  if (email.trim() === "") {
    response.push("email");
  }
  if (phoneNumber.trim() === "") {
    response.push("phoneNumber");
  }
  return response
};

export const validateAddStudentFormStepTwo = (
  payeeId,
  admissionDate
) => {
  let response = [];
  if (payeeId.trim() === "") {
    response.push("payeeId");
  }
  if (admissionDate.trim() === "") {
    response.push("admissionDate");
  }
  return response
};

export const validateAddUserForm = (
  firstName,
  lastName,
  phone,
  password,
  email,
  birth,
  area,
  gender,
  region,
  designation,
  nationality,
  address,
  role
) => {
  let response = [];
  if (firstName?.trim() === "") {
    response.push("firstName");
  }
  if (lastName?.trim() === "") {
    response.push("lastName");
  }
  if (phone?.trim() === "") {
    response.push("phone");
  }
  if (password?.trim() === "") {
    response.push("password");
  }
  if (designation?.trim() === "") {
    response.push("designation");
  }
  if (area?.trim() === "") {
    response.push("area");
  }
  if (region?.trim() === "") {
    response.push("region");
  }
  if (address?.trim() === "") {
    response.push("address");
  }
  if (nationality?.trim() === "") {
    response.push("nationality");
  }
  if (gender?.trim() === "") {
    response.push("gender");
  }
  if (birth === "") {
    response.push("birth");
  }
  if (role === "") {
    response.push("role");
  }
  if (email.trim() === "" || !validator.isEmail(email)) {
    response.push("email");
  }
  return response;
};

export const validateEditUserForm = (
  firstName,
  lastName,
  phone,
  birth,
  area,
  gender,
  region,
  designation,
  nationality,
  address,
  role
) => {
  let response = [];
  if (firstName?.trim() === "") {
    response.push("firstName");
  }
  if (lastName?.trim() === "") {
    response.push("lastName");
  }
  if (phone?.trim() === "") {
    response.push("phone");
  }
  if (designation?.trim() === "") {
    response.push("designation");
  }
  if (area?.trim() === "") {
    response.push("area");
  }
  if (region?.trim() === "") {
    response.push("region");
  }
  if (address?.trim() === "") {
    response.push("address");
  }
  if (nationality?.trim() === "") {
    response.push("nationality");
  }
  if (gender?.trim() === "") {
    response.push("gender");
  }
  if (birth === "") {
    response.push("birth");
  }
  if (role === "") {
    response.push("role");
  }
  return response;
};

export const validateAddBankForm = (
  bankSwiftCode,
  bankAddress,
  accountNumber,
  accountTitle,
  accountIban,
) => {
  if (bankSwiftCode.trim() === "") {
    return {
      status: false,
      type: "bankSwiftCodeError",
    };
  }
  if (bankAddress.trim() === "") {
    return {
      status: false,
      type: "bankAddressError",
    };
  }

  if (accountNumber.trim() === "") {
    return {
      status: false,
      type: "accountNumberError",
    };
  }

  if (accountTitle.trim() === "") {
    return {
      status: false,
      type: "accountTitleError",
    };
  }

  if (accountIban.trim() === "") {
    return {
      status: false,
      type: "accountIbanError",
    };
  }

  return { status: true, type: "" };
};